<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('prodInstructions.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content">
            <div v-if="type=='TA806'">
                <div class="top-box">
                    <van-row gutter="6">
                        <van-col span="8">
                            <div class="box-item" @click="to806Quick">
                                <img class="box-img1" src="@/assets/theme/light/desc/01prodInstructions/01box.svg">
                                <div class="box-title">{{$t('prodInstructions.quick')}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="problem-title">{{$t('prodInstructions.question')}}</div>
                <div class="problem-box">
                    <div class="problem-item first-item" @click="toArticle(13)">
                        {{$t('prodInstructions.compass')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(15)">
                        {{$t('prodInstructions.height')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toAndroidMessage">
                        {{$t('prodInstructions.android')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toIosMessage">
                        {{$t('prodInstructions.ios')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toKeepAlive">
                        {{$t('prodInstructions.keepAlive')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item  last-item" @click="toSamSet">
                        {{$t('prodInstructions.restricted')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                </div>
            </div>
            <div v-if="type=='TA900'">
                <div class="top-box">
                    <van-row gutter="6">
                        <van-col span="8">
                            <div class="box-item" @click="to900Quick">
                                <img class="box-img1" src="@/assets/theme/light/desc/01prodInstructions/01box.svg">
                                <div class="box-title">{{$t('prodInstructions.quick')}}</div>
                            </div>
                        </van-col>
                        <van-col span="8" v-if="$i18n.locale==='zh'">
                            <div class="box-item" @click="toVideoOperationTA900">
                                <img class="box-img2" src="@/assets/theme/light/desc/01prodInstructions/02box.svg">
                                <div class="box-title">{{$t('prodInstructions.video')}}</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="box-item" @click="toDescTA900">
                                <img class="box-img3" src="@/assets/theme/light/desc/01prodInstructions/03box.svg">
                                <div class="box-title">{{$t('prodInstructions.desc')}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="problem-title">{{$t('prodInstructions.question')}}</div>
                <div class="problem-box">
                    <div class="problem-item first-item" @click="toArticle(13)">
                        {{$t('prodInstructions.compass')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(14)">
                        {{$t('prodInstructions.sleep')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(15)">
                        {{$t('prodInstructions.height')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toMap900">
                        {{$t('prodInstructions.map')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toAndroidMessage">
                        {{$t('prodInstructions.android')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toIosMessage">
                        {{$t('prodInstructions.ios')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toKeepAlive">
                        {{$t('prodInstructions.keepAlive')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item  last-item" @click="toSamSet">
                        {{$t('prodInstructions.restricted')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                </div>
            </div>
            <div v-if="type=='TA600'">
                <div class="top-box">
                    <van-row gutter="6">
                        <van-col span="8" v-if="$i18n.locale==='zh'">
                            <div class="box-item" @click="toVideoOperationTA600">
                                <img class="box-img2" src="@/assets/theme/light/desc/01prodInstructions/02box.svg">
                                <div class="box-title">{{$t('prodInstructions.video')}}</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="box-item" @click="toDescTA600">
                                <img class="box-img3" src="@/assets/theme/light/desc/01prodInstructions/03box.svg">
                                <div class="box-title">{{$t('prodInstructions.desc')}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="problem-title">{{$t('prodInstructions.question')}}</div>
                <div class="problem-box">
                    <div class="problem-item first-item" @click="toArticle(13)">
                        {{$t('prodInstructions.compass')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(14)">
                        {{$t('prodInstructions.sleep')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(15)">
                        {{$t('prodInstructions.height')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(16)">
                        {{$t('prodInstructions.ecg')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toAndroidMessage">
                        {{$t('prodInstructions.android')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toIosMessage">
                        {{$t('prodInstructions.ios')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toKeepAlive">
                        {{$t('prodInstructions.keepAlive')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item  last-item" @click="toSamSet">
                        {{$t('prodInstructions.restricted')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                </div>
            </div>
            <div v-if="type=='TA610'">
                <div class="top-box">
                    <van-row gutter="6">
                        <van-col span="8" v-if="$i18n.locale==='zh'">
                            <div class="box-item" @click="toVideoOperationTA600">
                                <img class="box-img2" src="@/assets/theme/light/desc/01prodInstructions/02box.svg">
                                <div class="box-title">{{$t('prodInstructions.video')}}</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="box-item" @click="toDescTA610">
                                <img class="box-img3" src="@/assets/theme/light/desc/01prodInstructions/03box.svg">
                                <div class="box-title">{{$t('prodInstructions.desc')}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="problem-title">{{$t('prodInstructions.question')}}</div>
                <div class="problem-box">
                    <div class="problem-item first-item" @click="toArticle(13)">
                        {{$t('prodInstructions.compass')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(14)">
                        {{$t('prodInstructions.sleep')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(15)">
                        {{$t('prodInstructions.height')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(16)">
                        {{$t('prodInstructions.ecg')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toAndroidMessage">
                        {{$t('prodInstructions.android')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toIosMessage">
                        {{$t('prodInstructions.ios')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toKeepAlive">
                        {{$t('prodInstructions.keepAlive')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item  last-item" @click="toSamSet">
                        {{$t('prodInstructions.restricted')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                </div>
            </div>
            <div v-if="type=='TA2000'">
                <div class="top-box">
                    <van-row gutter="6">
                        <van-col span="8" v-if="$i18n.locale==='zh'">
                            <div class="box-item" @click="toVideoOperationTA2000">
                                <img class="box-img2" src="@/assets/theme/light/desc/01prodInstructions/02box.svg">
                                <div class="box-title">{{$t('prodInstructions.video')}}</div>
                            </div>
                        </van-col>
                        <van-col span="8">
                            <div class="box-item" @click="toDescTA2000">
                                <img class="box-img3" src="@/assets/theme/light/desc/01prodInstructions/03box.svg">
                                <div class="box-title">{{$t('prodInstructions.desc')}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="problem-title">{{$t('prodInstructions.question')}}</div>
                <div class="problem-box">
                    <div class="problem-item first-item" @click="toArticle(13)">
                        {{$t('prodInstructions.compass')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(14)">
                        {{$t('prodInstructions.sleep')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(15)">
                        {{$t('prodInstructions.height')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(16)">
                        {{$t('prodInstructions.ecg')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toAndroidMessage">
                        {{$t('prodInstructions.android')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toIosMessage">
                        {{$t('prodInstructions.ios')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toKeepAlive">
                        {{$t('prodInstructions.keepAlive')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toSamSet">
                        {{$t('prodInstructions.restricted')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item last-item" @click="toMap(13)">
                        <span>{{$t('prodInstructions.map')}}</span>
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                </div>
            </div>
            <div v-if="type=='TA700'">
                <div class="top-box">
                    <van-row gutter="6">
                        <van-col span="8">
                            <div class="box-item" @click="toDescTA700">
                                <img class="box-img3" src="@/assets/theme/light/desc/01prodInstructions/03box.svg">
                                <div class="box-title">{{$t('prodInstructions.desc')}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="problem-title">{{$t('prodInstructions.question')}}</div>
                <div class="problem-box">
                    <div class="problem-item first-item" @click="toArticle(13)">
                        {{$t('prodInstructions.compass700')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(14)">
                        {{$t('prodInstructions.sleep')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(15)">
                        {{$t('prodInstructions.height')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(16)">
                        {{$t('prodInstructions.ecg')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toAndroidMessage">
                        {{$t('prodInstructions.android')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toIosMessage">
                        {{$t('prodInstructions.ios')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toKeepAlive">
                        {{$t('prodInstructions.keepAlive')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item  last-item" @click="toSamSet">
                        {{$t('prodInstructions.restricted')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                </div>
            </div>
            <div v-if="type=='TA3000'">
                <div class="top-box">
                    <van-row gutter="6">
                        <van-col span="8">
                            <div class="box-item" @click="toDescTA3000">
                                <img class="box-img3" src="@/assets/theme/light/desc/01prodInstructions/03box.svg">
                                <div class="box-title">{{$t('prodInstructions.desc')}}</div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="problem-title">{{$t('prodInstructions.question')}}</div>
                <div class="problem-box">
                    <div class="problem-item first-item" @click="toArticle(13)">
                        {{$t('prodInstructions.compass700')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(14)">
                        {{$t('prodInstructions.sleep')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(15)">
                        {{$t('prodInstructions.height')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toArticle(16)">
                        {{$t('prodInstructions.ecg')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toAndroidMessage">
                        {{$t('prodInstructions.android')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toIosMessage">
                        {{$t('prodInstructions.ios')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item" @click="toKeepAlive">
                        {{$t('prodInstructions.keepAlive')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                    <div class="problem-item  last-item" @click="toSamSet">
                        {{$t('prodInstructions.restricted')}}
                        <img class="to-prob-img" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {WebJSBridge} from "../../utils/JSBridge1";

    export default {
        name: 'prodInstructions',
        data() {
            return {
                type: '',
                maxKbScript: null,
                baseUrl: '',
                theme: '',
                from: '',
            }
        },
        mounted() {
            this.baseUrl = window.location.origin;
            this.type = this.$route.query.type;
            if (this.$route.query.from) {
                this.from = this.$route.query.from;
            }
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme;
            }
            // this.loadMaxKbScript();
        },
        beforeDestroy() {
            // this.removeMaxKbScript();
        },
        methods: {
            back() {
                if (this.from == 'web') {
                    this.$router.back();
                } else {
                    WebJSBridge.call("closeWeb", null, function (res) {
                    });
                }
            },
            toArticle(id) {
                let lang = this.$i18n.locale;
                if (lang == 'en') {
                    if (id == 13) {
                        id = 25
                    } else if (id == 14) {
                        id = 26
                    } else if (id == 15) {
                        id = 27
                    } else if (id == 16) {
                        id = 28
                    }
                } else if (lang == 'ja') {
                    if (id == 13) {
                        id = 68
                    } else if (id == 14) {
                        id = 69
                    } else if (id == 15) {
                        id = 70
                    } else if (id == 16) {
                        id = 71
                    }
                }
                window.location.href = this.baseUrl + '/bdwatch_web/view/article.html?id=' + id;
            },
            to806Quick() {
                window.location.href = 'https://mp.weixin.qq.com/s/cCIgx15wNBYUuy2mTeTGPw'
            },
            toAndroidMessage() {
                this.$router.push({
                    name: 'androidMessageSet',
                    query: {
                        lang: this.$i18n.locale
                    }
                })
            },
            toIosMessage() {
                this.$router.push({
                    name: 'iosMessageSet',
                    query: {
                        lang: this.$i18n.locale
                    }
                })
            },
            toSamSet() {
                this.$router.push({
                    name: 'samSet',
                    query: {
                        lang: this.$i18n.locale
                    }
                })
            },
            toKeepAlive() {
                this.$router.push({
                    name: 'keepAlive',
                    query: {
                        lang: this.$i18n.locale
                    }
                })
            },
            toMap() {
                this.$router.push({
                    name: 'ta2000desc'
                })
            },
            toMap900() {
                this.$router.push({
                    name: 'ta900desc'
                })
            },
            to900Quick() {
                window.location.href = this.baseUrl + '/bdwatch_web/view/TA900QuickStart.html'
            },
            toVideoOperationTA900() {
                window.location.href = this.baseUrl + '/bdwatch_web/view/videoOperation.html'
            },
            toDescTA900() {
                window.location.href = this.baseUrl + '/bdwatch_web/view/TA900Desc.html?chapter=rssb'
            },
            toVideoOperationTA600() {
                window.location.href = 'https://m.bilibili.com/video/BV1Au4y1N7j7'
            },
            toDescTA600() {
                window.location.href = this.baseUrl + '/bdwatch_web/view/TA600Desc.html?chapter=jccz'
            },
            toDescTA610() {
                window.location.href = this.baseUrl + '/bdwatch_web/view/TA610Desc.html?chapter=jccz'
            },
            toVideoOperationTA2000() {
                window.location.href = this.baseUrl + '/bdwatch_web/view/TA2000VideoOperation.html'
            },
            toDescTA2000() {
                window.location.href = this.baseUrl + '/bdwatch_web/view/TA2000Desc.html?chapter=rssb'
            },
            toDescTA700() {
                let lang = this.$i18n.locale;
                if (lang == 'en') {
                    window.location.href = this.baseUrl + '/bdwatch_web/view/TA700DescEn.html?chapter=jccz'
                } else if (lang == 'ja') {
                    window.location.href = this.baseUrl + '/bdwatch_web/view/TA700DescJa.html?chapter=jccz'
                } else {
                    window.location.href = this.baseUrl + '/bdwatch_web/view/TA700Desc.html?chapter=jccz'
                }
            },
            toDescTA3000() {
                let lang = this.$i18n.locale;
                if (lang == 'en') {
                    window.location.href = this.baseUrl + '/bdwatch_web/view/TA3000DescEn.html?chapter=jccz'
                } else if (lang == 'ja') {
                    window.location.href = this.baseUrl + '/bdwatch_web/view/TA3000DescJa.html?chapter=jccz'
                } else {
                    window.location.href = this.baseUrl + '/bdwatch_web/view/TA3000Desc.html?chapter=jccz'
                }
            },
            toVideoOperationTA700() {
                this.$router.push({
                    name: 'ta700video'
                })
            },
            loadMaxKbScript() {
                console.log('loadMaxKbScript');
                let maxKb = document.getElementById('maxkb');
                if (maxKb) {
                    maxKb.style.display = 'block';
                }
                const script = document.createElement('script');
                script.async = true;
                script.defer = true;
                script.src = 'https://service.beidouwatch.com/api/application/embed?protocol=https&host=service.beidouwatch.com&token=3a8b66e71698bb52';
                document.body.appendChild(script);
                this.maxKbScript = script;
            },
            removeMaxKbScript() {
                console.log('removeMaxKbScript');
                if (this.maxKbScript && this.maxKbScript.parentNode) {
                    this.maxKbScript.parentNode.removeChild(this.maxKbScript);
                }
                let maxKb = document.getElementById('maxkb');
                if (maxKb) {
                    maxKb.style.display = 'none';
                }
            }
        }
    }
</script>

<style scoped>
    .top-box {
        width: 345px;
        height: 91px;
        margin: 12px auto;
    }

    .box-item {
        height: 91px;
        width: 100%;
        background-color: var(--bg-color-2);
        border-radius: 10px;
        position: relative;
    }

    .box-img1 {
        width: 33px;
        top: 15px;
        position: absolute;
        left: 40px;
    }

    .box-img2 {
        width: 51px;
        top: 20px;
        position: absolute;
        left: 33px;
    }

    .box-img3 {
        width: 38px;
        top: 18px;
        position: absolute;
        left: 37px;
    }

    .box-title {
        color: var(--text-color-1);
        font-size: 15px;
        position: absolute;
        top: 63px;
        text-align: center;
        width: 100%;
    }

    .problem-title {
        color: var(--text-color-1);
        font-size: 17px;
        margin-left: 15px;
        margin-top: 20px;
    }

    .problem-box {
        width: 345px;
        background: var(--bg-color-2);
        opacity: 1;
        border-radius: 13px;
        margin: 10px auto 10px;
        color: var(--text-color-1);
    }

    .problem-item {
        padding: 12px 0;
        width: 290px;
        margin: 0 0 0 20px;
        font-size: 15px;
        position: relative;
    }

    .first-item {
        padding-top: 24px;
    }

    .last-item {
        padding-bottom: 24px;
    }

    .to-prob-img {
        position: absolute;
        right: -20px;
        height: 16px;
        top: 15px;
        width: 12px;
    }

    .first-item .to-prob-img {
        top: 26px;
    }
</style>



// WEBPACK FOOTER //
// src/views/desc/01prodInstructions.vue